<cms-spinner></cms-spinner>
<cms-main-menu *ngIf="authService.isLoggedIn"></cms-main-menu>
<main class="main-content"
      [class.main-content__with-menu]="authService.isLoggedIn && isMainMenuShown && layoutService.isDesktop">
  <router-outlet></router-outlet>
</main>
